<generic-page
  image="calculatorEligible"
  [hidePortalMenu]="true"
  [showAppHeader]="false"
  [columnLayout]="false"
  >
  <div class="container">
    <mat-card>
      <div class="property-address">{{ formattedAddressForDisplay() }}</div>

      <div class="header">
        <span>The property is eligible!</span>
      </div>

      <div class="description">
        <span
          >See available terms and estimated monthly costs below based on a project cost of
          {{ estimatedCost$ | async | currency : 'USD' : 'symbol' : '1.0-0' }}.</span
          >
        </div>

        <div class="terms-container">
          @for (costInfo of estimatedCostInfo$ | async; track costInfo) {
            <div class="term-card">
              <span class="term-year">{{ costInfo.term }} years</span>
              <span class="term-amount"
                >{{ costInfo.monthly_cost | roundUp | currency : 'USD' : 'symbol' : '1.0-0' }}/mo</span
                >
                <span class="term-percent"
                  >Interest rate:{{ costInfo.interest_rate / 100 | percent : '1.1-3' : 'en-US' }}</span
                  >
                  <span class="term-percent"
                    >APR:{{ costInfo.apr / 100 | percent : '1.2-2' : 'en-US' }}</span
                    >
                  </div>
                }
              </div>

              <form [formGroup]="costForm" (ngSubmit)="submit()">
                <mat-form-field floatLabel="always">
                  <mat-label>Change project cost (Min $5000)</mat-label>
                  <fa-icon matPrefix [icon]="['fas', 'dollar-sign']"></fa-icon>
                  <input
                    matInput
                    [placeholder]="estimatedCost$ | async | currency : 'USD' : '' : '1.0-0'"
                    [thousandSeparator]="maskConfig.thousandSeparator"
                    [mask]="moneyMaskWithoutDecimal"
                    numberInput
                    formControlName="estimated_cost"
                    [separatorLimit]="maskConfig.separatorLimit"
                    autofocus
                    />

                  @if (costForm.get('estimated_cost').hasError('required')) {
                    <mat-error
                      >Please enter a valid project cost</mat-error
                      >
                    }

                    @if (costForm.get('estimated_cost').hasError('min')) {
                      <mat-error>
                        Project cost must be a minimum of $5000
                      </mat-error>
                    }

                    @if (costForm.get('estimated_cost').hasError('max')) {
                      <mat-error>
                        Project cost must be a maximum of $100,000,000
                      </mat-error>
                    }
                  </mat-form-field>

                  <div class="button-wrapper">
                    <page-button
                      [config]="{ arrow: false, rank: 'secondary-grey' }"
                      [loading]="isLoading$ | async"
                      >Recalculate</page-button
                      >
                    </div>
                  </form>

                  <div class="disclaimer-section">
                    <p class="sub-heading">Important information:</p>
                    <ul>
                      <li>* Term limitations and other conditions may apply</li>
                      <li>* Property qualification and financing approval are subject to underwriting</li>
                      <li>* Includes Estimated Program Fees</li>
                    </ul>
                  </div>

                  @if (isDesktop$ | async) {
                    <div class="button-wrapper check-another-property">
                      <page-button [config]="{ arrow: 'right' }" (clicked)="navigate()"
                        >Check Another Property</page-button
                        >
                      </div>
                    }
                  </mat-card>
                </div>
              </generic-page>

              @if (!(isDesktop$ | async)) {
                <div class="footer-wrapper" noShadowOnBottom>
                  <page-footer
                    [primary]="{ label: 'Check Another Property', arrow: 'right' }"
                    [primCenteredIfNoSecondary]="true"
                    (primaryClicked)="navigate()"
                    [valid]="true"
                  ></page-footer>
                </div>
              }
